
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios'
import {message} from 'antd'
import keyUri from '../../key'

export const initialState = {

    loading: false,
    hasErrors: false,
    news:[],
    currentnews:null,
}

export const newsSlice = createSlice({
    name:"news",
    initialState,
    reducers:{

        getNews: state =>{

            state.loading = true
        },

        getNewsSuccess: (state, {payload}) =>{
            state.loading = false
            state.news = payload
            
        },

        getCurrentNews: (state, {payload}) =>{
          console.log({k:payload});

            state.loading = false
            state.currentnews = payload
            
        },
        getNewsFailure: (state, {payload}) =>{

            state.loading = false
            state.news = payload
            
        },

    }
})

export const {getNews, getNewsSuccess, getCurrentNews, getNewsFailure } = newsSlice.actions
      
export const newsSelector = state => state.news
export default newsSlice.reducer


const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };



export const  fetchAllNews = () => async dispatch =>{
      const key = "news"
      dispatch(getNews())
      
    try {

        const {data} = await axios.get(keyUri.BACKEND_URI +'/news');
        console.log(data)
        dispatch(getNewsSuccess(data))

    } catch ({response}) {

        dispatch(getNewsFailure())
        response.data && message.error({ content: response.data.msg, key, duration: 2 });

    }
    
}

export const  fetchOneNews = (id) => async dispatch =>{

    dispatch(getNews())
    
  try {

      const {data} = await axios.get(keyUri.BACKEND_URI +`/new/${id}`);
      dispatch(getCurrentNews(data))

  } catch ({response}) {

      dispatch(getNewsFailure())
    //   response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  createNews = (values) => async dispatch =>{
  console.log(values);
    const key = "news"
    dispatch(getNews())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.post(keyUri.BACKEND_URI +'/news', values, config);
      setTimeout(() => {

        message.success({ content: data.msg, key, duration: 2 });
      }, 500) 
        dispatch(fetchAllNews())

  } catch ({response}) {
       dispatch(getNewsFailure())
  }
  
}


export const  deleteNews = (id) => async dispatch =>{
    const key = "news"
    dispatch(getNews())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.delete(keyUri.BACKEND_URI +`/news/${id}`);
      data && message.success({ content: data.msg, key, duration: 2 });
      dispatch(fetchAllNews())

  } catch ({response}) {

      dispatch(getNewsFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  updateNews = (id, values) => async dispatch =>{
    const key = "news"
    dispatch(getNews())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.put(keyUri.BACKEND_URI +`/news/${id}`, values, config);
      data && message.success({ content: data.msg, key, duration: 2 });
      window.location.reload()
      dispatch(fetchAllNews())

  } catch ({response}) {

      dispatch(getNewsFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}




